export default {
  burgerMenu: 50,
  navigation: 40,
  header: 30,
  dropdown: 10,
};
